document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    threshold: 0.95,
  };
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        // handling for scroll up - maybe use a scroll tracker?
        if (document.body.classList.contains("scroll-up")) {
          const slideNumber = entry.target.dataset.slide;

          const fellowImage = document.querySelector(
            `.featured-image-content__image-wrapper--${slideNumber}`
          );

          // target the one below it, if there then do something to it
          const next = fellowImage.nextElementSibling;

          if (next) {
            fellowImage.classList.add("current-section");
            next.classList.remove("current-section");
          }
        }
        return;
      } else {
        const sibling = entry.target.nextElementSibling;
        if (sibling) {
          const slideNumber = sibling.dataset.slide;

          const fellowImage = document.querySelector(
            ".featured-image-content__image-wrapper--" + slideNumber
          );

          if (fellowImage) {
            fellowImage.classList.add("current-section");
          }
        }
      }
    });
  }, observerOptions);

  const targets = document.querySelectorAll(
    ".featured-image-content__block-wrapper"
  );

  if (targets) {
    targets.forEach((target) => {
      observer.observe(target);
    });
  }
});
